import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { clone, mapKeys, snakeCase } from 'lodash-es';
import { Observable } from 'rxjs';
import { DeviceInventoryModel } from '../../../../../../../../core/me/_models/DeviceInventory.model';
import { GeneralAutocompleteComponent } from '../../../../../../../partials/layout/general-autocomplete/general-autocomplete.component';
import { ContactRelationshipsService } from '../../../../../../../../core/lists/_services';
import { GeneralValidationMessagesService } from '../../../../../../../../core/services/general-validation-messages.service';
import { DeviceService } from '../../../../../../../../core/me/_services/device.service';
import { DeviceInventoryService } from '../../../../../../../../core/me/_services/device-inventory.service';
import { AppState } from '../../../../../../../../core/reducers';
import { currentUser } from '../../../../../../../../core/auth';
import { PatientRangesComponent } from '../../../../../../me/device/patient-ranges/patient-ranges.component';

@Component({
  selector: 'kt-assign-device',
  templateUrl: './assign-device.component.html',
  styleUrls: ['./assign-device.component.scss'],
})
export class AssignDeviceComponent implements OnInit {
  disableBtns: any;
  deviceInventoryForm: FormGroup;
  model: DeviceInventoryModel = new DeviceInventoryModel();
  private companyId: any;
  filteredPatient: Observable<any>;
  filteredDevices: Observable<any>;
  inventoryForm: any;
  showRangeForm = false;
  rangeModel: any;
  patientRangesSet = true;
  rangesRequierd = false;
  private deviceTempValue: { id: number; name: any };
  private patientTempValue;
  @ViewChild('patientInput', { static: true }) patientInput: ElementRef;
  hasFormErrors = false;
  deviceId = 0;
  @ViewChild('deviceAutocomplete') deviceAutocomplete: GeneralAutocompleteComponent;
  filterDevicesFn = this.deviceService.searchDevices.bind(this.deviceService);
  @ViewChild('inventoryAutocomplete') inventoryAutocomplete: GeneralAutocompleteComponent;
  patient_id: any;
  filterInventoryFn = this.deviceInventoryService.searchInventories.bind(
    this.deviceInventoryService,
    this.deviceId,
  );
  readOnlyInventory = true;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<AssignDeviceComponent>,
    private fb: FormBuilder,
    private contactRelationshipsService: ContactRelationshipsService,
    public validationMessageService: GeneralValidationMessagesService,
    private deviceService: DeviceService,
    private deviceInventoryService: DeviceInventoryService,
    private store: Store<AppState>,
    public dialog: MatDialog,
  ) {
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
    this.model = this.data.model;
    this.patient_id = this.data.patientId;
  }

  ngOnInit(): void {
    this.initForm();
  }

  onCancelClick() {
    this.close(false);
  }
  changeDevice() {
    this.readOnlyInventory = true;
  }
  onSubmit() {
    this.hasFormErrors = false;
    const controls = this.deviceInventoryForm.controls;
    this.inventoryAutocomplete.updateValueAndValidity();
    this.deviceAutocomplete.updateValueAndValidity();
    if (this.deviceInventoryForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    }
    const patientValue = this.patient_id ? true : false;
    if (patientValue && this.patientRangesSet === false) {
      this.rangesRequierd = true;
      return;
    }
    this.disableBtns = true;
    this.deviceInventoryForm.disable();
    let model = clone(this.deviceInventoryForm.value);
    const patient = this.patient_id;
    model.patient_id = this.patient_id ? this.patient_id.id : null;
    model.device_id = model.device_id ? model.device_id.id : null;
    model.inventory_id = model.inventory_id ? model.inventory_id.id : null;
    model = mapKeys(model, (value, key) => snakeCase(key));
    const date = new Date(model.date_assigned);
    const offset = date.getTimezoneOffset();
    if (offset < 0) {
      date.setHours(12, 0, 0);
    }
    model.date_assigned = date.toISOString().substring(0, 10);
    if (model.patient_id) {
      this.deviceInventoryService
        .submitPatientRanges(model.patient_id, model.device_id, this.rangeModel)
        .subscribe(() => {
          const body = {
            active: true,
            patient,
            date_assigned: model.date_assigned,
          };
          this.deviceInventoryService
            .assignedPatient(body, model.inventory_id)
            .subscribe((result) => {
              if (result && result.id) {
                this.close(true);
              }
            });
        });
    }
  }

  private initForm() {
    this.deviceInventoryForm = this.fb.group({
      inventory_id: [],
      date_assigned: [Validators.required],
      device_id: [],
    });
  }

  getErrorMessage(control) {
    return this.validationMessageService.getMessage(control);
  }

  get date_assigned() {
    return this.deviceInventoryForm.get('date_assigned');
  }

  set date_assigned(val) {
    this.deviceInventoryForm.get('date_assigned').value(val);
  }

  get device_id() {
    return this.deviceInventoryForm.get('device_id');
  }

  set device_id(val) {
    this.deviceInventoryForm.get('device_id').value(val);
  }

  get inventory_id() {
    return this.deviceInventoryForm.get('inventory_id');
  }

  set inventory_id(val) {
    this.deviceInventoryForm.get('inventory_id').value(val);
  }

  private close(needReload: boolean) {
    this.dialogRef.close({
      reload: needReload,
    });
  }

  displayPatient(patient: any) {
    if (patient && typeof patient === 'object') {
      return patient.first_name + ' ' + patient.last_name;
    }
  }

  selectAuto() {
    this.showRangeForm = false;
    const formRangeId =
      this.device_id.value && this.device_id.value.form_id ? this.device_id.value.form_id : 0;
    if (this.device_id.value && this.patient_id)
      this.deviceInventoryService
        .getPatientRange(this.device_id.value.id, this.patient_id)
        .subscribe(
          (res) => {
            if (res && res.length > 0) {
              this.patientRangesSet = true;
              this.showRangeForm = true;
              this.rangeModel = res[0].range;
              // return;
            }

            this.deviceInventoryService.getInventoryForm(formRangeId).subscribe((formRes) => {
              this.inventoryForm = JSON.parse(formRes.data.schema);
            });
          },
          () => {
            this.deviceInventoryService.getInventoryForm(formRangeId).subscribe((formRes) => {
              this.inventoryForm = JSON.parse(formRes.data.schema);
              this.showRangeForm = true;
              this.patientRangesSet = false;
            });
          },
        );
  }

  openPatientRanges() {
    const dialogRef = this.dialog.open(PatientRangesComponent, {
      data: {
        model: this.rangeModel,
        inventoryForm: this.inventoryForm,
      },
      width: '400px',
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.data) {
        this.rangeModel = res.data;
        this.patientRangesSet = true;
      }
    });
  }

  findPatient() {
    const model = clone(this.deviceInventoryForm.value);
    const patient = model.patient_id;
    if (patient && patient.id) {
      this.patientRangesSet = false;
      return;
    }
    this.patientRangesSet = true;
  }
  getNamePatient(val) {
    const first = val && val.first_name ? val.first_name : '';
    const last = val && val.last_name ? val.last_name : '';
    return first + ' ' + last;
  }
  displayDevice(device: any) {
    if (device && typeof device === 'object') {
      return device.name;
    }
  }
  displayInventory(device: any) {
    if (device && typeof device === 'object') {
      return device.serial_id;
    }
  }
  selectDevice(value) {
    this.deviceInventoryForm.get('device_id').setValue(value);
    this.deviceId = value ? value.id : '';
    this.filterInventoryFn = this.deviceInventoryService.searchInventories.bind(
      this.deviceInventoryService,
      this.deviceId,
    );
    this.readOnlyInventory = false;
  }

  selectInventory(value) {
    this.deviceInventoryForm.get('inventory_id').setValue(value);
    this.device_id.value.form_id = value.form_id;
    this.rangeModel = {};
    this.patientRangesSet = false;
    this.selectAuto();
  }
}
